import React, { forwardRef } from "react";

interface RadioButtonProps {
    label: string; value: string;
    name: string;
    selectedValue: string;
    radioClass?: string;
    radioTextClass?: string;
    register?: any;
}

const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(({
    label,
    value,
    name,
    selectedValue,
    radioClass,
    radioTextClass,
    ...register
}, ref) => (
    <div className={`${radioClass}`}>
        <label
            key={value}
            className="inline-flex items-center gap-x-2.5 cursor-pointer"
        >
            <input
                ref={ref}
                type="radio"
                name={name}
                value={value}
                defaultChecked={selectedValue === value}
                className="shrink-0 size-4 border-gray-300 text-blue-600"
                {...register}
            />
            <span className={`text-sm text-gray-700 font-medium ${radioTextClass}`}>{label}</span>
        </label>
    </div>
));

export default RadioButton;
